import { type PropsWithChildren } from 'react'

import { Skeleton } from '@ds/components'

import styles from './CommentList.module.css'

const SKELETON_COUNT = 3

export const CommentListSection = ({ children }: PropsWithChildren) => (
    <div className={styles.section}>{children}</div>
)

export const CommentComposerFrame = ({ children }: PropsWithChildren) => (
    <div className={styles.composerFrame}>{children}</div>
)

export const CommentListLoading = () => (
    <div className={styles.loading}>
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
            <Skeleton key={index} className={styles.skeleton} />
        ))}
    </div>
)

export const CommentListError = ({ message }: { message: string }) => (
    <p className={styles.error}>{message}</p>
)

export const CommentList = ({ children }: PropsWithChildren) => (
    <ul className={styles.list}>{children}</ul>
)

export const CommentListItem = ({ children }: PropsWithChildren) => (
    <li className={styles.item}>{children}</li>
)
